import moment from "moment";
import { AiOutlineCaretDown } from "react-icons/ai";
import { BiLoaderCircle } from "react-icons/bi";
import ReactPaginate from "react-paginate";
import { Tooltip } from "react-tooltip";

const NFTStatusTable = ({
  list,
  loader,
  handlePageClick,
  sortStatusTable,
  pagination,
  sortBy,
  sortDir,
}) => {
  const roundToTwoDecimalPlaces = (input) => {
    const number = parseFloat(input);

    if (typeof number === "number" && !Number.isNaN(number) && number !== 0) {
      const roundedNumber = parseFloat(number.toFixed(2));
      return roundedNumber.toLocaleString();
    }

    if (isNaN(number)) {
      return 0;
    }

    return input;
  };

  return (
    <div className="bg-white w-full">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[1000px]">
          <thead>
            <tr>
              <th className="font-medium text-gray-600 px-1 py-2 text-[15px]" colSpan="4">Product</th>
              <th className="font-medium text-gray-600 px-1 py-2 text-[15px]" colSpan="4">Seller</th>
              <th className="font-medium text-gray-600 px-1 py-2 text-[15px]" colSpan="3">Buyer</th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th
                onClick={() => sortStatusTable("offer_id")}
                className="border border-l-0 text-center cursor-pointer font-medium text-gray-600 px-1 py-2 text-[12px] group"
              >
                <div className="flex items-center justify-center gap-1 whitespace-nowrap">
                  Sales Id
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "offer_id" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("category")}
                className="border border-l-0 text-center cursor-pointer font-medium text-gray-600 px-1 py-2 text-[12px] group"
              >
                <div className="flex items-center justify-center gap-1">
                  Category
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "category" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("item_title")}
                className="border border-l-0 text-center cursor-pointer font-medium text-gray-600 px-1 py-2 text-[12px] group"
              >
                <div className="flex items-center justify-center gap-1">
                  Product
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "item_title" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("offer_item_price")}
                className="border border-l-0 text-center cursor-pointer font-medium text-gray-600 px-1 py-2 text-[12px] group"
              >
                <div className="flex items-center justify-center gap-1">
                  Prices
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "offer_item_price" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("offer_price_usd")}
                className="border border-l-0 text-center cursor-pointer font-medium text-gray-600 px-1 py-2 text-[12px] group"
              >
                <div className="flex items-center justify-center gap-1">
                  Prices
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "offer_price_usd" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("offer_date")}
                className="border px-1 py-2 text-[12px] cursor-pointer whitespace-nowrap font-medium text-gray-600 text-left group"
              >
                <div className="flex items-center gap-1">
                  Date
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "offer_date" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("seller_name")}
                className="border px-1 py-2 text-[12px] cursor-pointer whitespace-nowrap font-medium text-gray-600 text-center group"
              >
                <div className="flex items-center justify-center gap-1">
                  Player
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "seller_name" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("seller_referal")}
                className="border px-1 py-2 text-[12px] cursor-pointer whitespace-nowrap font-medium text-gray-600 text-left group"
              >
                <div className="flex items-center gap-1">
                  Referral
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "seller_referal" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("sold_date")}
                className="border px-1 py-2 text-[12px] cursor-pointer whitespace-nowrap font-medium text-gray-600 text-left group"
              >
                <div className="flex items-center gap-1">
                  Date
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "sold_date" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("buyer_name")}
                className="border px-1 py-2 text-[12px] cursor-pointer whitespace-nowrap font-medium text-gray-600 text-center group"
              >
                <div className="flex items-center justify-center gap-1">
                  Player
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "buyer_name" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
              <th
                onClick={() => sortStatusTable("buyer_referal")}
                className="border px-1 py-2 text-[12px] cursor-pointer whitespace-nowrap font-medium text-gray-600 text-left group"
              >
                <div className="flex items-center gap-1">
                  Referral
                  <AiOutlineCaretDown
                    size={16}
                    className={`transform ${
                      sortBy === "buyer_referal" ? "" : "hidden"
                    } ${
                      sortDir === "asc" ? "rotate-[180deg]" : ""
                    } transition-opacity duration-300 ease-in-out group-hover:block shrink-0`}
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {loader ? (
              <tr>
                <td colSpan={25}>
                  <div className="text-center p-[28px] flex items-center justify-center">
                    <BiLoaderCircle
                      size={62}
                      className="animate-[spin_3s_linear_infinite] text-[#0080A6]"
                    />
                  </div>
                </td>
              </tr>
            ) : (
              list?.map((sales, key) => (
                <tr key={key}>
                  <td className="border first:border-l-0 last:border-r-0 text-center font-medium text-gray-600 px-1 py-2 text-[12px] whitespace-nowrap ">
                    {sales.offer_id || "-"}
                  </td>
                  <td className="border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-gray-600 text-left">
                    {sales.category || "-"}
                  </td>
                  <td className="border first:border-l-0 last:border-r-0 text-left font-medium text-gray-600 px-1 py-2 text-[12px]  ">
                    <div
                      className="w-[150px] flex items-center gap-2"
                      data-tooltip-id={key + "country"}
                    >
                      <img
                        className="w-[30px]"
                        src={sales.item_img || "-"}
                        alt={sales.item_title || "-"}
                      />
                      {sales.item_title}
                    </div>
                    {/* <Tooltip id={key + "country"}>{sales.product}</Tooltip> */}
                  </td>
                  <td
                    className={`border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-left`}
                  >
                    <div
                      className="w-[70px] flex items-center gap-2"
                      data-tooltip-id={key + "country"}
                    >
                      <img
                        className="w-[15px]"
                        src={sales.offer_item_image}
                        alt={sales.offer_item_price}
                      />
                      {sales.offer_item_price || "-"}
                    </div>
                  </td>
                  <td
                    className={`border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-left`}
                  >
                    ${roundToTwoDecimalPlaces(sales.offer_price_usd) || "-"}
                  </td>
                  <td
                    className={`border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-left`}
                  >
                    {sales.offer_date ? moment(sales.offer_date).format("YYYY/MM/DD") : "-"}

                  </td>
                  <td
                    title={sales.seller_name}
                    className={`border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-left`}
                  >
                    {sales.seller_name ? 
                      (sales.seller_name.length > 12 ? `${sales.seller_name.slice(0, 12)}...` : sales.seller_name) : 
                      "-"
                    }
                  </td>
                  <td
                    className={`border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-left`}
                  >
                    {sales.seller_referal || "-"}
                  </td>
                  <td
                    className={`border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-left`}
                  >
                    {sales.sold_date ? moment(sales.sold_date).format("YYYY/MM/DD") : "-"}
                  </td>
                  <td
                    title={sales.buyer_name }
                    className={`border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-left`}
                  >
                    {sales.buyer_name ? 
                      (sales.buyer_name.length > 12 ? `${sales.buyer_name.slice(0, 12)}...` : sales.buyer_name) : 
                      "-"
                    }
                  </td>
                  <td
                    title={sales.buyer_referal}
                    className={`border px-1 py-2 text-[12px] whitespace-nowrap font-medium text-left`}
                  >
                    {sales.buyer_referal ? 
                      (sales.buyer_referal.length > 12 ? `${sales.buyer_referal.slice(0, 12)}...` : sales.buyer_referal) : 
                      "-"
                    }
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="tokenomics-pagination py-10 mr-6">
        <ReactPaginate
          breakLabel="..."
          nextLabel={null}
          previousLabel={null}
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pagination?.totalPages}
          forcePage={pagination?.previousPage}
          marginPagesDisplayed={2}
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default NFTStatusTable;
